import { render, staticRenderFns } from "./collect_main.vue?vue&type=template&id=77953853&scoped=true&"
import script from "./collect_main.vue?vue&type=script&lang=js&"
export * from "./collect_main.vue?vue&type=script&lang=js&"
import style0 from "./collect_main.vue?vue&type=style&index=0&id=77953853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77953853",
  null
  
)

export default component.exports